import React, { lazy } from "react";

const LazyNotifications = lazy(() => import("./Notifications"));

const Notifications = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyNotifications {...props} />;

export default Notifications;
